export const faqData = [
  {
    id: "1",
    question: "DO YOU SHIP ANYWHERE IN BANGLADESH ?",
    answer:
      "Yes! It takes 1 day* in Dhaka city to deliver the order. For other parts of the country, it takes 1-3 days* to deliver as we have to depend on courier services (mostly Sundarban Courier Service). *It may vary depending many unavoidable circumstances.",
  },
  {
    id: "2",
    question: "WHO SHOULD I TO CONTACT IF I HAVE ANY QUERIES ?",
    answer:
      "You can contact us at support@robodocbd.com or can call us at (+88) 01322 908 240.",
  },
  {
    id: "3",
    question: "HOW DO I TRACK MY ORDER ?",
    answer:
      "Please sign up if you are not signed up yet. After signing in there is an option in the right bottom corner of the website (Desktop view) or at the end of the homepage (Mobile view)! Just click that or go to this Track Order.",
  },
  {
    id: "4",
    question: "HOW CAN I CANCEL OR CHANGE MY ORDER ?",
    answer:
      "As we deliver in 1 day*, we just take our orders till 12.00 A.M (for delivering it on the next day). You can cancel or change your order till 12.00 A.M. After that, we start processing all the orders which will be delivered on the next day.",
  },
  {
    id: "5",
    question: "HOW CAN I RETURN A PRODUCT",
    answer:
      "If the product is not what you ordered for or the product is broken/damaged while carrying or the product does not match with the description, then you can return that product instantly. Please read our Terms and Conditions first(Trak Order). We accept returns for any unaffected development board, IC, tool, and/or cable within 3 calendar days from the date of delivery. After such time, all sales are considered as final. 'Unaffected' means the device was not powered up, programmed, or somehow changed. We cannot accept returns on purchased items that had electrical power applied to them, or programmed, changed, or affected in any way.",
  },
  {
    id: "6",
    question: "HOW LONG WILL IT TAKE TO GET MY PACKAGE ?",
    answer:
      "It usually takes one business day (9 A.M to 9 P.M) to deliver a product. You've to order before 12.00 A.M to get your product on the next day. Suppose, you ordered some equipment on 12th January at 10.00 A.M then you'll get your product on 13th January*. To get the product on 13th January you must confirm or done with any kind of change in your order between 12.00 A.M to 11.59 A.M in 12th January. It also depends on the availability of the product. Delivery might be delayed due to unavoidable circumstances.",
  },
  {
    id: "7",
    question: "WHAT SHIPPING METHODS ARE AVAILABLE ?",
    answer:
      "We believe in 'give and take'. We deliver the products and then pay for it. So, cash on delivery is preferable though payment through bKash and Rocket is also available.",
  },
  {
    id: "8",
    question: "DO YOU PROVIDE ANY WARRANTY ?",
    answer:
      "We always value our customers the most and try our level best to guarantee the maximum satisfaction. If a particular product has any warranty only then warranty is applicable. In case, if you are not satisfied with our products or there is any problem with it, please inform us as soon as possible by dropping a mail to support@robodocbd.com.",
  },
  {
    id: "9",
    question:
      "HOW CAN I CHANGE QUANTITIES OF ANY ITEM ONCE I'VE ADDED THEM TO MY CART OR I'VE ALREADY ORDERED ?",
    answer:
      "If you've added an item to your cart, and then you want the number of the item to increase or decrease, then go to your shopping cart and enter the quantity you want to purchase in the quantity box or click the arrow keys. You can click the trash icon if you don't want the item. The page will be updated automatically. If you are done, then 'Checkout'.",
  },
  {
    id: "10",
    question:
      "I HAVE MADE SOMETHING THAT YOU GUYS MAY FEEL INTERESTED IN IT. HOW CAN I CONTACT WITH YOU ?",
    answer:
      "We always appreciate this kind of responses. Just email contact@robodocbd.com and please leave a description of your project. If this is something we are interested in and able to marketize it, we'll contact you as soon as possible. It may take us a while to get back to you as we receive a lots of emails each day.",
  },
  {
    id: "11",
    question: "WHAT IS INSTANT DELIVERY ?",
    answer:
      "'Instant delivery' means the order will be delivered within 4 hours from the order placement time. In case of emergency need of equipment, you can use this service. This service is not available all over Bangladesh. It's currently available in some selected zones of Dhaka city. The order will be processed with urgency and delivered within time. If the order is not delivered in the next 4 hours from your order placing time, then you'll get the delivery absolutely free of delivery charge! The instant delivery option is valid only from 8 A.M to 5 P.M of a day except for the weekend and other holidays. For example: If you order at 4 P.M, you'll get it by 8 P.M. Additionally, you should consider unavoidable circumstances like weather, strike etc. and you (the recipient) must be present at the given address in the selected zone during the time of delivery. In case of unavoidable circumstances, this rule (free delivery charge) will not be maintained.",
  },
];
